"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.collations = void 0;
/* @generated */
// prettier-ignore
exports.collations = ["big5han", "compat", "dict", "direct", "ducet", "emoji", "eor", "gb2312", "phonebk", "phonetic", "pinyin", "reformed", "search", "searchjl", "standard", "stroke", "trad", "unihan", "zhuyin"];
